import storage from "./../storage";

interface Status {
  nbForms: number;
  processing: boolean;
  stoppedProcessingRecently: boolean;
  isAnyError: boolean;
  timers: ReturnType<typeof setTimeout>[];
  init: () => Promise<void>;
}

const formSyncStatusChannel = new BroadcastChannel("form-sync-status-channel");

async function updateFormsSync(status: Status) {
  let isAnyProcessing = false;
  let isAnyError = false;
  await storage.iterate({ storeName: "forms" }, (value) => {
    if (value !== null && typeof value === "object" && "status" in value) {
      if (value?.status === "processing") {
        isAnyProcessing = true;
      } else if (value?.status === "error") {
        isAnyError = true;
      }
    }
  });
  const nbForms = (await storage.keys({ storeName: "forms" })).length;
  status.nbForms = nbForms;
  status.isAnyError = isAnyError;

  if (status.processing && !isAnyProcessing) {
    // Delay 2000ms to match the toast notification in `handleSubmitForm`
    status.timers.push(
      setTimeout(() => {
        status.processing = false;
        status.stoppedProcessingRecently = true;
      }, 2000),
    );
    status.timers.push(
      setTimeout(() => {
        status.stoppedProcessingRecently = false;
      }, 7000),
    );
    return;
  }
  if (status.stoppedProcessingRecently && isAnyProcessing) {
    for (const t of status.timers) {
      clearTimeout(t);
    }
    status.timers = [];
    status.stoppedProcessingRecently = false;
  }
  status.processing = isAnyProcessing;
}

function alpineData() {
  return {
    nbForms: 0,
    processing: false,
    stoppedProcessingRecently: false,
    isAnyError: false,
    timers: [],
    async init() {
      updateFormsSync(this);

      formSyncStatusChannel.onmessage = async (event) => {
        if (event.data === "update") {
          updateFormsSync(this);
        }
      };
    },
  } as Status;
}

export default alpineData;
